import React, { useState } from "react";
import "./General.css";
import { UpdateSiteLiveStatus } from "./Requests";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess,
  notifyInfo,
  notifyWarn,
} from "../../Response/ResposeHandler";
import { useTranslation } from "react-i18next";

const General = (props) => {
  const { t } = useTranslation("miniSiteGeneral");
  const [isLive, setIsLive] = useState(props.site.isLive);
  const [liveError, setLiveError] = useState();

  function LiveToggleHandler(e) {
    const next = e.target.checked;
    UpdateSiteLiveStatus(next)
      .then((res) => {
        if (res.status === 200 && next === true) {
          notifySuccess(t("toasts.siteOnline"));
          setIsLive(true);
        }
        if (res.status === 200 && next === false) {
          notifySuccess(t("toasts.siteOffline"));
          setIsLive(false);
        }
        setLiveError();
      })
      .catch((error) => {
        const msg = error?.response?.data;
        if (msg === "Site settings are missing") {
          notifyWarn(t("toasts.unableToPublish"));
          setLiveError(t("errors.settingsMissing"));
          setIsLive(false);
        } else {
          notifyError(t("toasts.genericError"));
          setIsLive((v) => v); // no change
        }
      })
      .finally(() => {});
  }

  const bookingUrl = `${process.env.REACT_APP_CLIENT_BASE_URL}make-a-booking?id=${props.shopId}`;
  const miniSiteUrl = `${process.env.REACT_APP_CLIENT_BASE_URL}client-site?site=${props.shopId}`;

  return (
    <div style={{ marginLeft: "auto", marginRight: "auto" }}>
      <ToastContainer />

      <div className="gen-wrap">
        {/* Live toggle card */}
        <div className="mini-card-general gen-card">
          {liveError && (
            <div className="gen-error" role="alert">
              {liveError}
            </div>
          )}

          <div className="gen-toggleRow">
            <div className="gen-toggleText">
              <h3 className="gen-h3">{t("titles.liveStatus")}</h3>
              <p className="gen-muted">{t("descriptions.liveStatus")}</p>
            </div>

            {/* Accessible switch */}
            <div className="sectionToggle">
              <input
                className="toggle-switch"
                type="checkbox"
                checked={isLive}
                id="live-toggle"
                onChange={LiveToggleHandler}
                aria-label={t("labels.liveToggle")}
              />
              <label htmlFor="live-toggle" className="switch-label" />
            </div>
          </div>
        </div>

        {/* Links row */}
        <div className="gen-grid">
          {/* Booking portal card */}
          <div className="mini-card-general gen-card">
            <div className="gen-cardHead">
              <h3 className="gen-h3">{t("titles.bookingPortal")}</h3>
              <p className="gen-muted">{t("descriptions.bookingPortal")}</p>
            </div>

            <div className="mini-linkRow">
              <a
                target="_blank"
                rel="noreferrer"
                className="mini-link"
                href={`make-a-booking?id=${props.shopId}`}
                title={t("actions.openBookingPortal")}
                aria-label={t("actions.openBookingPortal")}
              >
                {bookingUrl}
              </a>

              <button
                type="button"
                className="mini-copyBtn"
                aria-label={t("actions.copyBookingLink")}
                onClick={async () => {
                  notifyInfo(t("toasts.copiedBookingLink"));
                  try {
                    await navigator.clipboard.writeText(bookingUrl);
                  } catch {}
                }}
                title={t("actions.copyLink")}
              >
                <svg viewBox="0 0 24 24" className="mini-copyIcon" aria-hidden="true">
                  <path d="M16 1H6a2 2 0 0 0-2 2v11h2V3h10V1zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H10V7h9v14z" />
                </svg>
              </button>
            </div>
          </div>

          {/* Mini site card */}
          <div className="mini-card-general gen-card">
            <div className="gen-cardHead">
              <h3 className="gen-h3">{t("titles.miniSite")}</h3>
              <p className="gen-muted">{t("descriptions.miniSite")}</p>
            </div>

            <div className="mini-linkRow">
              <a
                target="_blank"
                rel="noreferrer"
                className="mini-link"
                href={`client-site?site=${props.shopId}`}
                title={t("actions.openMiniSite")}
                aria-label={t("actions.openMiniSite")}
              >
                {miniSiteUrl}
              </a>

              <button
                type="button"
                className="mini-copyBtn"
                aria-label={t("actions.copyMiniSiteLink")}
                onClick={async () => {
                  notifyInfo(t("toasts.copiedMiniLink"));
                  try {
                    await navigator.clipboard.writeText(miniSiteUrl);
                  } catch {}
                }}
                title={t("actions.copyLink")}
              >
                <svg viewBox="0 0 24 24" className="mini-copyIcon" aria-hidden="true">
                  <path d="M16 1H6a2 2 0 0 0-2 2v11h2V3h10V1zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H10V7h9v14z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
